import React, { Component } from 'react'
import { ASPHAULT, MIDNIGHT_BLUE, SILVER } from '../utils/colors'
import { Link } from 'react-router-dom'


class Navbar extends Component {

    state = {
        active: false
    }

    render() {
        const active = this.state.active ? 'is-active' : ''

        return (
            <div className='navbar is-transparent' style={{backgroundColor: MIDNIGHT_BLUE}}>
                <div className='navbar-brand'>
                    <div className={`navbar-burger burger ${active}`} onClick={this.toggle} style={{color: SILVER}} data-target='navMenu'>
                        <span /><span /><span />
                    </div>
                </div>

                <div id='navMenu' className={`navbar-menu ${active}`} style={{backgroundColor: MIDNIGHT_BLUE}}>
                    <div className='navbar-end'>
                        <Link className='navbar-item' style={{color: SILVER, backgroundColor: ASPHAULT}} to='/'>About</Link>
                        <Link className='navbar-item' style={{color: SILVER, backgroundColor: ASPHAULT}} to='/work'>Work</Link>
                        <Link className='navbar-item' style={{color: SILVER, backgroundColor: ASPHAULT}} to='/portfolio'>Portfolio</Link>
                    </div>
                </div>
            </div>
        )
    }

    toggle = () => {
        this.setState({ active: !this.state.active })
    }

}


export default Navbar



// WEBPACK FOOTER //
// ./src/components/navbar.js